<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="100px" class="info-form">
        <el-form-item label="商品分类">
          <div class="goods-category-edit">
            <span>{{ infoForm.categoryLabel }}</span>
            <!-- <span class="edit-btn" @click="toEditCategory" v-if="infoForm.platformIdOrigin != 0">编辑</span> -->
          </div>
        </el-form-item>
        <el-form-item label="商品类型">
          {{ infoForm.typeLabel }}
          <!-- <el-radio-group v-model="infoForm.goodsType" :disabled="currentPageStatus !== 'add'">
            <el-radio v-for="item in goods_types" :key="item.dictId" :value="item.dictId" :label="item.dictName"
              :name="item.dictId"></el-radio>
          </el-radio-group> -->
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input style="width: 442px" v-model="infoForm.name" placeholder="请输入商品名称" maxlength="30" show-word-limit
            clearable></el-input>
        </el-form-item>
        <!-- <div label="" style="
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 0px;
            color: #909099;
            margin-left: 106px;
            margin-top: 24px;
            margin-bottom: 18px;
          ">
          示例：商品品牌-商品属性-商品名称-商品重量
        </div> -->
        <el-form-item label="商品编号" class="goods-no">
          <el-input v-model="infoForm.goodsNo" style="width: 442px" disabled></el-input>
        </el-form-item>
        <el-form-item label="排序" class="sort">
          <el-input v-model="infoForm.sort" style="width: 442px"></el-input>
        </el-form-item>
        <div style="
            width: 674px;
            height: 0px;
            border: 1px dashed #ebebfa;
            opacity: 1;
            margin-bottom: 6px;
          "></div>
        <el-form-item label="类目属性">
          <label slot="label"><span style="
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 0px;
                color: #303033;
              ">类目属性</span></label>
          <div class="content attr" style="padding: 0px 0px !important">
            <div class="attr-content" style="background-color: white">
              <template v-for="(item, index) in goodsAttrData">
                <h5 style="color: #303033">商品属性/{{ item.name }}</h5>
                <div class="attr-list">
                  <form-filed1 v-if="isUpdate" :formconfig="item.formconfig" :formData="item.formData"
                    @formDataval="dialogClick" :ref="'formAttr' + item.id" />
                  <form-filed v-else :formconfig="item.formconfig" :formData="item.formData" @formDataval="dialogClick"
                    :ref="'formAttr' + item.id" />
                </div>
              </template>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>筛选标签设置</h3>
      <el-form label-width="100px">
        <el-form-item :label="item.label" v-for="(item, index) in tagIds1" :key="index">
          <el-select style="width: 442px" :placeholder="'请选择' + item.label + '(可多选)'" multiple v-model="Tag[index]"
            @change="selectT($event, index)">
            <el-option v-for="(item, index) in item.children" :key="item.value" :value="item.value" :label="item.label">

            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <h3>展示标签设置</h3>
      <el-form label-width="100px">
        <el-form-item :label="item.label" v-for="(item, index) in tagIdsShow1" :key="index">
          <el-select style="width: 442px" :placeholder="'请选择' + item.label + '(可多选)'" multiple v-model="Tag1[index]"
            @change="selectTs($event, index)">
            <el-option v-for="(item, index) in item.children" :key="item.value" :value="item.value" :label="item.label">

            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <h3>营销标签设置</h3>
      <el-form label-width="100px" class="info-form">
        <el-form-item label="选择标签">
          <el-select style="width: 442px" v-model="tagMarketingsT" placeholder="请选择标签（可多选）" ref="refTag"
            @change="changeD($event)" @visible-change="changeTag($event)" multiple v-if="!isSelect">
            <el-option v-for="item in tagMarketings" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <div
            style="width:442px;min-height: 38px;border-radius: 4px;border: 1px solid #DCDFE6;display: flex;justify-content: space-between;"
            v-else @click="openSelect">
            <div v-if="tagMarketing.length == 0" style="margin-left:15px;color: #c0c9db;">请选择标签（可多选）</div>
            <draggable v-else @start="start" @end="end" v-model="tagMarketing"
              style="display: flex;padding:8px 8px;flex-wrap: wrap;">
              <div v-for="(item, index) in tagMarketing" :key="index" effect="dark" closable
                style="margin-right:10px;margin-bottom: 4px;" class="dItem">
                <div style="display: flex;">
                  <div style="margin-left: 6px;"> {{ item.name }}</div>
                  <div
                    style="background-color: #c0c4cc;width:12.8px;height:12.6px;border-radius: 50%;color:#909399;margin-top: 5px;margin-left: 6px;margin-right: 6px;">
                    <div style="margin-top: -5px;"><i style="font-size: 10px;" class="el-icon-close"></i></div>

                  </div>
                </div>

              </div>
            </draggable>
            <div style="margin-right: 12px;display: flex;flex-direction: column;justify-content: center;"><i
                style="color: #C0C4CC;font-size: 14px;" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>运费设置</h3>
      <el-form label-width="100px">
        <el-form-item label="运费设置">
          <el-select style="width: 442px" v-model="infoForm.shippingTemplateId" @change="getTransportModel">
            <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <!-- <el-radio-group v-model="radio">
            <el-radio :label="3">按件数</el-radio>
            <el-radio :label="6">按重量</el-radio>
          </el-radio-group> -->
          <number v-if="detail.calculType == 1" :isEdit="false" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice"></number>
          <weight v-if="detail.calculType == 2" :isEdit="false" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice"></weight>
          <free-delivery v-if="tableDataF.length != 0" :tableData="tableDataF" style="margin-top: 10px"
            :isEdit="false"></free-delivery>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>图文信息</h3>
      <el-form label-width="100px">
        <el-form-item label="商品图片(0/10)">
          <label slot="label"><span style="color: red">*</span>商品图片({{
            this.fileList.length
          }}/10)</label>
          <!-- <div style="display: flex" v-if="isUpdate">
            <div class="itemI" style="margin-left: 8px" v-for="(item, index) in fileList" :key="item + index">
              <el-image style="width: 108px; height: 108px; border-radius: 6px" :src="item.url"></el-image>
              <span v-if="index == 0" style="
                  color: #2d46ee;
                  position: absolute;
                  top: 100px;
                  left: 10px;
                ">（商品主图）</span>
            </div>
          </div> -->

          <upload-picture :limit="10" :list="fileList" @changeImage="changeImage" />
          <!--          <upload-picture></upload-picture>-->
        </el-form-item>
        <el-form-item label="">
          <div style="
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 16px;
              color: #909099;
            ">
            图片尺寸：建议上传750px*750px，每张上传大小不得超过2M,支持jpg、jpeg、png格式
          </div>
        </el-form-item>
        <el-form-item label="商品详情">
          <label slot="label"><span style="color: red">*</span>商品详情</label>
          <!--          <editor :init="editorInit" v-model="infoForm.detail" api-key="70xmc76i21jyu8ob8fmf4dtcjfpz0atkne1ttkxppmzsu230"/>-->
          <!-- <tinymce v-model="infoForm.details"></tinymce> -->
          <quill-editor v-model="infoForm.details" ref="myQuillEditor" :options="editorOption"
            class="editor"></quill-editor>
          <div class="bottom" style="display: none">
            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
              :on-change="handleAvatarChangeIcon" ref="uploadicon">
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" id="sku-content">
      <div style="display: flex">
        <h3>价格库存</h3>
      </div>

      <div class="sku-box">
        <div class="sku-title"></div>
        <div class="sku-content-box">
          <div class="goods-sale-list">
            <SkuForm ref="skuForm" :source-attribute="skuFormConfig.sourceAttribute"
              :attribute.sync="skuFormConfig.attribute" :sku.sync="skuFormConfig.sku" :disabled="skuFormConfig.showForm"
              :structure="skuFormConfig.structure">
              <template #image="slotImg">
                <!-- <img :src="slotImg.row.image" style="width:64px;height:64px"></img> -->
                <mall-picture :imageUrl="slotImg.row.image" @getUrl="getImage($event, slotImg)"></mall-picture>
              </template>
              <template #settlementPrice="slotProps">
                {{
                  slotProps.row.settlementPrice
                  ? Number(slotProps.row.settlementPrice)
                    .toFixed(3)
                    .substring(
                      0,
                      Number(slotProps.row.settlementPrice)
                        .toFixed(3)
                        .lastIndexOf(".") + 3
                    )
                  : "0.00"
                }}
              </template>
              <template #status="slotProps">
                <el-switch active-color="#2D46EE" v-model="slotProps.row.status" active-value="1" inactive-value="0"
                  @change="changeStatus(slotProps.row, slotProps.$index)"></el-switch>
              </template>
              <template #marketPrice="slotProps">
                <el-input v-model="slotProps.row.marketPrice" @change="changeM('marketPrice', slotProps.$index)"
                  size="small"></el-input>
              </template>
              <template #retailPrice="slotProps">
                <el-input v-model="slotProps.row.retailPrice" @change="changeM('retailPrice', slotProps.$index)"
                  size="small"></el-input>
              </template>
              <!-- 内购价放这里 -->
              <template #purchasePrice="slotProps">
                <el-input v-model="slotProps.row.purchasePrice" @change="changeM('purchasePrice', slotProps.$index)"
                  size="small" disabled></el-input>
              </template>
              <template #weight="slotProps">
                {{ slotProps.row.weight ? Number(slotProps.row.weight) : "0" }}
              </template>
              <template #wyStatus="slotProps">
                {{ slotProps.row.wyStatus == 1 ? '上架' : "下架" }}
              </template>
              <template #stock="slotProps">
                <el-input v-model="slotProps.row.stock" disabled size="small"></el-input>
              </template>
              <template #initSellNum="slotProps">
                <el-input v-model="slotProps.row.initSellNum" size="small"></el-input>
              </template>
              <template #skuNo="slotProps">
                {{ slotProps.row.skuNo ? slotProps.row.skuNo : "- -" }}
              </template>
              <template #skuB="slotProps">
                {{ slotProps.row.skuB ? slotProps.row.skuB : "- -" }}
              </template>
              <template #bindingSkuNo="slotBindingSkuNo">
                <!-- <span v-if="slotHandSkuNo.row.handSkuNo">{{ slotHandSkuNo }}</span> -->
                <el-button type="text" @click="showDialogSkuVisible($event, slotBindingSkuNo)">手动绑定SKU</el-button>
              </template>
            </SkuForm>
          </div>
        </div>
      </div>
    </div>

    <div class="content bottom-but">
      <el-button type="info" @click="back">返回</el-button>
      <el-button type="primary" @click="verificationData()">修改商品</el-button>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isUp" width="518px" :append-to-body="true">
      <template>
        <div style="display: flex">
          <div class="info">
            <i class="el-icon-warning" style="color: red; font-size: 16px"></i>
          </div>
          <div style="margin-left: 8px; margin-top: -2px">
            <div class="info-item" v-for="(item, index) in skuFormConfig.sku" :key="index">
              <div style="display: flex; flex-wrap: wrap">
                <div style="color: #2d46ee">{{ item.sku }}</div>
                设置的【盈利金额】为
                <div v-if="item.platformProfitPrice >= 0" style="color: #13ce4b">
                  {{
                    Number(item.platformProfitPrice)
                      .toFixed(3)
                      .substring(
                        0,
                        Number(item.platformProfitPrice)
                          .toFixed(3)
                          .lastIndexOf(".") + 3
                      )
                  }}
                </div>
                <div v-else style="color: #f63c56">
                  {{
                    Number(item.platformProfitPrice)
                      .toFixed(3)
                      .substring(
                        0,
                        Number(item.platformProfitPrice)
                          .toFixed(3)
                          .lastIndexOf(".") + 3
                      )
                  }}
                </div>
                元!
              </div>
              <div class="info-b">
                该SKU商品设定【恢复原价个数】为：{{
                  item.resetPriceNum || 0
                }}件<span v-if="item.platformProfitPrice < 0">，扣除保证金<span style="color: #f63c56">
                    {{
                      Number(
                        Math.abs(
                          Number(item.resetPriceNum) *
                          Number(item.platformProfitPrice) || 0
                        )
                      )
                        .toFixed(3)
                        .substring(
                          0,
                          Number(
                            Math.abs(
                              Number(item.resetPriceNum) *
                              Number(item.platformProfitPrice) || 0
                            )
                          )
                            .toFixed(3)
                            .lastIndexOf(".") + 3
                        )
                    }}</span>元</span>
              </div>
            </div>
            <div class="info-bottom">
              <div class="info-bottom-item" v-if="profit == false">
                当前可用保证金余额为：<span style="color: #13ce4b">{{
                  activeEarnestMoney
                }}</span>元，将冻结<span style="color: #f63c56">{{
  awaitEarnestMoney1
}}</span>元！
              </div>
              <div class="info-bottom-item" v-if="Number(activeEarnestMoney) >= Number(awaitEarnestMoney1)">
                <span style="color: #f63c56">*注意：</span>当【恢复原价个数】已达上限，则该商品的【市场价、零售价】将自动恢复系统默认价格
              </div>
              <div class="info-bottom-item" style="color: #f63c56; font-size: 18px; font-weight: bold"
                v-if="Number(activeEarnestMoney) < Number(awaitEarnestMoney1)">
                保证金不足，请充值或修改商品数据！
              </div>
              <div class="info-bottom-item" v-if="Number(activeEarnestMoney) < Number(awaitEarnestMoney1)">
                【保证金充值】请前往<span style="color: #2d46ee">【财务管理】-【保证金】</span>进行充值
              </div>
            </div>
          </div>
        </div>

        <div style="
            display: flex;
            justify-content: end;
            margin-top: 24px;
            margin-right: 10px;
          ">
          <div class="info-q" @click="isUp = false">
            取消
          </div>
          <div class="info-s" @click="verificationData">
            确定上架
          </div>

        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isStatus" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="display: flex; flex-wrap: wrap; line-height: 20px">
          <i class="el-icon-warning" style="color: red; font-size: 16px"></i>是否<span
            v-if="currentData.status == 1">上架</span><span v-else>下架</span>【{{ currentData.sku }}】, 是否继续?
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isStatus = false">取消</div>
          <div class="info-s" @click="submitStatus">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isStatus1" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: red; font-size: 16px"></i>该商品五域系统已下架，系统不能操作系统上架！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isStatus1 = false">取消</div>
          <div class="info-s" @click="isStatus1 = false">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isInfo" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: red; font-size: 16px"></i>是否确认修改商品信息 ？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isInfo = false">取消</div>
          <div class="info-s" @click="verificationData">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isCostPrice" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning"
            style="color: red; font-size: 16px; line-height: 60px"></i>您已修改【成本价】，该商品需要下架后提交五域进行审核，
          审核通过后才能再次上架！是否下架提交审核?
        </div>
        <!-- <div style="text-align: center; margin-top: 10px; font-size: 18px">
          是否下架提交审核
        </div> -->
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isCostPrice = false">取消</div>
          <div class="info-s" @click="verificationData">提交审核</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="dialogCategory" append-to-body width="32%">
      <categoryDialog :categoryIds="cIds" @changeC="changeC"></categoryDialog>
    </el-dialog>
    <el-dialog title="选择商品" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods" width="50%">
      <div style="height: 500px; overflow-y: auto">
        <div class="search-box">
          <el-input placeholder="请输入商品名称/商品编号" size="small" style="width: 224px; margin-right: 20px"
            v-model="goodsName"></el-input>
          <el-button type="primary" @click="fetchDataG('search')" size="small">查询</el-button>
        </div>
        <el-table :data="goodsList" ref="multipleTable" @selection-change="handleSelectionChange" :show-header="false"
          border>
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="goodsName" label="">
            <template slot-scope="scope">
              <div style="display: flex">
                <img :src="scope.row.image" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                <div style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                  <p style="color: #333333">{{ scope.row.name }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[5, 10, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogGoods = false">取消</div>
        <div class="info-s" @click="selectData">确定</div>
      </div>
    </el-dialog>
    <el-dialog title="下架提示" :visible.sync="isU1" width="518px" :append-to-body="true" custom-class="infoI"
      top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left;">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>该商品下架，礼包商品<span
            v-if="gifts.length != 0">【</span>
          <span v-for="(item, index) in gifts" :key="index" style="color: red"><span v-if="index > 0"
              style="color: red">、</span>{{ item }}</span>
          <span v-if="gifts.length != 0">】</span>也会下架，是否确认下架？

        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isU1 = false">取消</div>
          <div class="info-s" @click="submitStatus">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册

// import Tinymce from '@/components/Tinymce/index'
import uploadPicture from '@/components/upload/dragpicture.vue'
// import sku from "./components/sku/index"
import formFiled from '@/components/form/index'
import formFiled1 from '@/components/form/indexL'
import SkuForm from 'vue-sku-form'
import mixinsGoodsEdit from '../mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from '../mixins/mixinsGoodsEditQuill.js'

import mixinsGiftlist from '../mixins/mixinsGiftlist.js'

import ModifyState from '../components/ModifyState.vue'

import common from '../mixins/common'
import number from '../components/number.vue'
import weight from '../components/weight.vue'
import FreeDelivery from '../components/freeDelivery.vue'
import mallPicture from '@/components/upload/mallPicture.vue'
import categoryDialog from '../components/categoryDialog.vue'
import draggable from 'vuedraggable'
const checkNumber = (data, index, callback) => {
  const val = data[index].stock
  // console.log(typeof val === 'number', !isNaN(val))
  console.log(typeof val === 'number' && !isNaN(val))
  if (!isNaN(val)) {
    callback()
  }
  callback(new Error('填写有误'))
}
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    formFiled,
    formFiled1,
    SkuForm,
    quillEditor,
    ModifyState,
    number,
    weight,
    FreeDelivery,
    mallPicture,
    categoryDialog,
    draggable
  },
  data() {
    return {
      isU1: false,
      gifts: [],
      isStatus1: false,
      isSelect: false,
      sTags: [],
      tags: [
        {
          id: '1',
          name: '十月'
        },
        {
          id: '2',
          name: '青少年'
        },
        {
          id: '3',
          name: '中年'
        },
        {
          id: '4',
          name: '过年'
        },
      ],
      goodsName: '',
      goodsList: [


      ],
      dialogGoods: false,
      cIds: [],
      dialogCategory: false,
      isChangeC: false,
      isChange: false,
      isCostPrice: false,
      currentIndex: 0,
      currentIndex1: null,
      currentData: {},
      isStatus: false,
      isInfo: false,
      time: 0,
      isUp: false,
      dataList: {
        list: [
          { title: '商品管理', path: '/shopManagement/shopList', type: '0' },
          { title: '商品列表', path: '/shopManagement/shopList', type: '1' },
          { title: '编辑商品', path: '', type: '2' }
        ]
      },
      searchList: {
        list: [
          { title: '商品分类', path: '', type: '0' },
          { title: '基础信息', path: '', type: '1' }
        ]
      },
      radio: 3,
      fileList: [],
      currentPageStatus: 'add', // 当前页面状态 add 添加 ， edit 编辑
      breadcrumbTitle: '新增商品',
      maxSkuNo: 1, // 通过接口获取最大 skuNo
      formFiledDataState: true, // 类目属性 状态
      skuFormConfig: {
        sourceAttribute: [], // SKU可选属性
        attribute: [], // SKU已选属性，支持 .sync 修饰符
        structure: [ // 表单结构
          {
            name: 'weight', type: 'slot', label: '重量(千克)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,

          },
          {
            name: 'marketPrice', type: 'slot', label: '市场价(元)', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   const val = data[index].marketPrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //     this.$forceUpdate()
            //     // this.skuItemHandle(data[index])
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'retailPrice', type: 'slot', label: '零售价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                // data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                data[index].platformCommission = Number((data[index].settlementPrice * this.serverRate) / 100)
                data[index].platformProfit = Number(data[index].retailPrice) - Number(data[index].settlementPrice)
                data[index].platformUserCommission = Math.floor(((data[index].retailPrice * data[index].platformCommissionRate) / 100) * 100) / 100 + Math.floor(((data[index].retailPrice * data[index].firstNormalCommProp) / 100) * 100) / 100
                // data[index].platformUserCommission = Number((data[index].retailPrice * data[index].platformCommissionRate) / 100)
                data[index].platformProfitPrice = Number(data[index].platformProfit) - Number(data[index].platformUserCommission)
                console.log(55555)


                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          //内购价
          {
            name: 'purchasePrice', type: 'slot', label: '内购价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].purchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].purchasePrice = Number(data[index].purchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
            tip: '库存为商品的总库存，库存为零自动下架', batch: false,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },

          {
            name: 'initSellNum', type: 'slot', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          { name: 'skuB', type: 'slot', label: 'SKU', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          {
            name: 'wyStatus',
            type: 'slot',
            defaultValue: '1',
            label: '五域商品状态',
            // tip: '单个 SKU 上架和下架状态！'
          }
        ],
        sku: [], // SKU数据，支持 .sync 修饰符
        theme: 2, // SKU选择栏主题风格，可选1或2
        showForm: true, // 是否显示SKU选择栏  false 显示 true 隐藏
        inputValueArr: [],
        inputValueArrTemp: []
      },
      isUpdate: false,
      submitButtonText: '发布商品', // 提交按钮方案
      infoForm: { // 基础信息
        categoryId: '', //	是	int	类目id （数据来源：接口 - /order/comm/commodityCategory/commList）
        goodsType: '', //	是	string	商品类型（字典：goods_type）
        name: '', //	是	string	商品名称
        brandId: '', //	是	int	品牌id（数据来源：接口 - /order/comm/brand/commList?pageNo=1&pageSize=999）
        attrList: '', //	是	Object[]	商品属性组列表
        // imageList: [{url: "http://fenxiao.muruji.com/internalSystem/76c19d4d-5a0e-4ff2-9b4f-239040be1d58"}], //	是	Object[]	图片列表
        imageList: [], //	是	Object[]	图片列表
        details: '', //	否	string	详情
        specList: [], //	是	Object[]	规格列表
        skuList: [], //	是	Object[]	sku列表
        status: '', //	是	string	状态（字典分组：enable_status）
        goodsNo: '', // 商品编号
        maxPrice: '', // 最高价
        minPrice: '', // 最低价
        submitButtonText: '发布商品', // 提交按钮方案
        tagList: [],//标签
        platformGoodsNo: '',
        tag: '',
        specDesc: '',
        tags: [],
        shippingTemplateId: '',
        sort: '',
      },
      infoRules: { // 基础验证
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        goodsType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      categoryIdArr: [], // 获取路由 categoryId
      categoryArrStr: '', // 回显 category
      goodsAttrDataList: [], // 类目商品属性库列表
      goodsSaleDataList: [], // 类目的销售属性列表
      goodsSaleDataListValue: [],
      goodsAttrData: [{ formconfig: {}, formData: {} }],
      formFiledData: {}, // 表单组件数 商品属性组列表
      currentStatus: 100, // 当前列表状态
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      selectionId: [], // 选 中 id
      parArray: [], // 按钮权限
      skuList: [],
      lastSkuStatus: [],
      changeGoodsStatusNum: 0,
      tagList: [],//标签
      seletedTag: [],
      dialogVisible: false,
      dialogSkuVisible: false,
      tagForm: {
        name: '',
        tagType: '1',
        tagClass: ''
      },
      labelPageNo: 1,
      labelPageSize: 10,
      labelTotalNum: 0,
      showTagDialog: false,
      tagSelectionList: [],
      bindingSkuNo: '',
      skuIndex: 0,
      editTagList: [],
      detail: {
        calculType: 0
      },
      tableData: [],
      tableDataF: [],
      hadRechargeAmount: 0,//已充值金额
      awaitEarnestMoney: 0,//冻结金额
      activeEarnestMoney: 0,//可用金额
      serverRate: 0,
      userRate: 0,
      firstNormalCommProp: 0,
      awaitEarnestMoney1: 0,//将冻结金额
      isSave: false,
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        }
      ],
      profit: true,//盈利
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      selectGoodsData: [],
      selectGoodsDatas: [],
      models: [
        {
          id: 0,
          name: '无'
        }
      ],
      tagIds: [],
      tagIds1: [],
      tagIds2: [],
      Tag: [],
      tag: [],
      tagStore: [],
      tagMarketing: [],
      tagIdsShow: [],
      tagIdsShow1: [],
      tagIdsShow2: [],
      Tag1: [],
      tagMarketings: [],
      tagMarketingsT: []
    }
  },
  mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill, mixinsGiftlist, common],
  // mounted () { this.addQuillTitle() },
  created() {
    this.initialization() // 初始化 信息
    // this.getPlatInfo()

  },
  watch: {
    infoForm: {
      handler(newVal, oldVal) {

        console.log(newVal.skuList)
        this.changeGoodsStatusNum++
      },
      deep: true
    },
    newObj: {
      // immediate: true, //true首次加载执行，默认false
      handler(newValue, oldValue) {
        // console.log("单个属性监听", newValue.sku, oldValue.sku);

      },
      deep: true,
      immediate: true
    },
    skuFormConfig: {
      handler(newVal, oldVal) {
        console.log(newVal.sku)
        this.$nextTick(() => {
          // this.$refs.skuForm.init()
          if (newVal) {
            newVal.sku.forEach(item => {
              this.$nextTick(() => {
                // item.stock = '1'

              })


              // this.skuItemHandle(item)

            })
            this.$forceUpdate()
            // console.log(this.skuList)
            // this.skuFormConfig = newVal
            // console.log(this.skuFormConfig)
          }
          if (this.skuList.length != 0) {
            // if (this.skuList[this.currentIndex].status == '1') {
            //   this.skuFormConfig.sku[this.currentIndex].status = '0'
            // } else {
            //   this.skuFormConfig.sku[this.currentIndex].status = '1'
            // }
            if (this.currentIndex1 != null) {
              console.log(this.skuList, this.skuList[this.currentIndex1].status, this.currentIndex1, this.skuFormConfig.sku)
              this.skuFormConfig.sku[this.currentIndex].status = String(this.skuList[this.currentIndex1].status)
            }

            // this.skuFormConfig.sku[this.currentIndex].wyStatus = String(this.skuList[this.currentIndex1].wyStatus)
            // this.skuFormConfig.sku[this.currentIndex].wyStatus = String(this.skuList[this.currentIndex].wyStatus)
            // if (this.skuList[this.currentIndex].wyStatus == 0) {
            //   this.skuFormConfig.sku[this.currentIndex].wyStatus = this.skuList[this.currentIndex].wyStatus
            // }

          }

          // this.$refs.skuForm.init()
          this.$forceUpdate()
        })
        // this.skuFormConfig.sku[this.currentIndex].status = String(this.skuList[this.currentIndex].status)

        const rQuery = this.$route.query
        this.$forceUpdate()
      },
      immediate: true,
      deep: true,// 为true，表示深度监听，这时候就能监测到a值变化
    },
    // goodsSaleDataListValue (a, b) {
    //   console.log(a, b)
    //   if (this.skuFormConfig.attribute.length > 3) {
    //     this.$message({
    //       message: '规格最多只有三条',
    //       type: 'warning'
    //     })
    //     this.onChangeGoodsSaleDataListValue(b)
    //   }
    // }
  },
  computed: {
    // newObj() {
    //   return JSON.parse(JSON.stringify(this.skuFormConfig));
    // },
    // numberC () {
    //   var s = Number(val).toFixed(2) + ""
    //   console.log(s, s.substring(0, s.indexOf(".") + 3))
    //   return 8888
    // }
  },
  methods: {
    changeM(key, index) {
      console.log(index)
      this.$nextTick(() => {
        this.$refs.skuForm.init()
        this.skuFormConfig.sku[index][key] = Number(this.skuFormConfig.sku[index][key]).toFixed(2)
        // console.log(this.skuFormConfig.sku[index].marketPrice, 5555)
        this.$forceUpdate()

      })

    },
    selectT(e, index) {
      // console.log(this.Tag, index, this.tagIds1)
      this.tag = []
      let tempArr = []
      this.tagIds1.forEach(item => {
        let obj = {
          id: item.value,
          name: item.label,
          selected: 0,
          childTags: []
        }
        tempArr.push(obj)
      })
      console.log(tempArr)
      for (let i = 0; i < tempArr.length; i++) {
        this.tagIds2.forEach(item => {
          if (this.Tag[i]) {
            this.Tag[i].forEach(itm => {
              if (itm == item.id) {
                let obj1 = {
                  id: item.id,
                  name: item.name,
                  selected: 1,
                  childTags: []
                }
                tempArr[i].childTags.push(obj1)
              }
            })
          }

        })

        let objectD = {
          id: tempArr[i].id,
          name: tempArr[i].name,
          selected: tempArr[i].selected,
          childTags: tempArr[i].childTags
        }
        this.tag.push(objectD)
      }
      console.log(this.tag)
    },
    selectTs(e, index) {
      // console.log(this.Tag1, index, this.tagIdsShow1)
      this.tagStore = []
      let tempArr = []
      this.tagIdsShow1.forEach(item => {
        let obj = {
          id: item.value,
          name: item.label,
          selected: 0,
          childTags: []
        }
        tempArr.push(obj)
      })
      console.log(tempArr)
      for (let i = 0; i < tempArr.length; i++) {
        this.tagIdsShow2.forEach(item => {
          if (this.Tag1[i]) {
            this.Tag1[i].forEach(itm => {
              if (itm == item.id) {
                let obj1 = {
                  id: item.id,
                  name: item.name,
                  selected: 1,
                  childTags: []
                }
                tempArr[i].childTags.push(obj1)
              }
            })
          }

        })

        let objectD = {
          id: tempArr[i].id,
          name: tempArr[i].name,
          selected: tempArr[i].selected,
          childTags: tempArr[i].childTags
        }
        this.tagStore.push(objectD)
      }
      console.log(this.tagStore)
    },
    openSelect() {
      this.isSelect = !this.isSelect
      this.$nextTick(() => {
        this.$refs['refTag'].toggleMenu()
      })
    },
    changeD(e) {
      console.log(this.tagMarketingsT, e)
      this.tagMarketing = []
      this.tagMarketings.forEach(item => {
        this.tagMarketingsT.forEach(itm => {
          if (item.id == itm) {
            let obj = {
              id: item.id,
              name: item.name,
              selected: 1
            }
            this.tagMarketing.push(obj)
          }
        })

      })
    },
    changeTag(e) {
      console.log(this.tagMarketingsT, e)
      this.tagMarketing = []
      if (!e) {
        this.isSelect = true
        this.tagMarketings.forEach(item => {
          this.tagMarketingsT.forEach(itm => {
            if (item.id == itm) {
              let obj = {
                id: item.id,
                name: item.name,
                selected: 1
              }
              this.tagMarketing.push(obj)
            }
          })

        })
      }
      console.log(this.tagMarketing)
    },
    end() {

    },
    start() {

    },
    deleteG(index) {
      this.selectGoodsDatas.splice(index, 1)
    },
    selectData() {
      console.log(this.selectGoodsDatas)
      this.selectGoodsDatas = this.setC(this.selectGoodsDatas.concat(this.selectGoodsData))
      console.log(this.selectGoodsDatas)
      this.dialogGoods = false
    },
    //去重
    setC(arr) {
      let newArr = []
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].id == arr[j].id) {
            arr.splice(j, 1)
            j--
          }
        }
      }
      return arr
    },
    fetchDataG() {
      this.pageNo = 1
      this.getGoods()
    },
    getGoods() {
      let data = {
        name: this.goodsName,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/goods/commendPsGoodsPageList', data).then(res => {
        if (res.code == 0) {
          this.goodsList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    handleCurrentChange(e) {
      this.pageNo = e
      this.getGoods()
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getGoods()
    },
    handleSelectionChange(e) {
      console.log(e)
      // this.selectGoodsData = e
      this.selectGoodsData = [...new Set(this.selectGoodsData.concat(e))]
    },
    selectG() {
      this.dialogGoods = true
      this.selectGoodsData = []
      this.getGoods()
    },
    changeC(val) {
      console.log(val)
      this.dialogCategory = false
      this.$router.push({
        name: 'shopAdd',
        query: { type: 'edit', category: val, id: this.$route.query.id }
      })
    },
    toEditCategory() {
      let ids = []
      this.infoForm.categoryInfoList.forEach(item => {
        if (item.level != 1) {
          ids.push(item.id)
        }

      })
      this.cIds = ids.reverse()
      console.log(this.cIds)
      this.dialogCategory = true

    },
    isEqualArray(arr1, arr2) {
      return Array.isArray(arr1) &&
        Array.isArray(arr2) &&
        arr1.length === arr2.length &&
        JSON.stringify(arr1) === JSON.stringify(arr2)
    },
    changeStatus(row, index) {

      this.currentData = row
      this.currentIndex = index
      this.currentIndex1 = this.skuList.findIndex((item) => item.skuNo == row.skuNo)
      this.$refs.skuForm.init()
      console.log(row.status)
      if (row.status == 0) {
        let data = {
          id: this.$route.query.id,
          sku: row.skuB,
          status: '0'
        }
        this.axios.post('/goods/checkGoodsBindingGfit', data).then(res => {
          if (res.code == 0) {
            this.gifts = res.data || []
            if (this.gifts.length == 0) {
              this.isStatus = true

            } else {
              this.isU1 = true
            }
          }
        })
      } else if (row.wyStatus == 0) {
        this.isStatus1 = true
        console.log(row.wyStatus)
        this.skuFormConfig.sku[index].wyStatus = row.wyStatus
      } else {
        this.isStatus = true
      }
      console.log(this.skuList[this.currentIndex1])
      // this.isStatus = true

      // this.skuFormConfig.sku[index].status = String(this.skuList[index].status)
      // this.skuFormConfig.sku[this.currentIndex].status = row.status
      // this.skuFormConfig.sku.forEach(item=>{
      //   this.skuList.forEach(itm=>{
      //     if(item.skuNo==itm.skuNo){
      //       item.wyStatus=itm.wyStatus
      //     }
      //   })
      // })
      // this.skuFormConfig.sku[0].wyStatus ='0'
      // console.log(this.skuFormConfig.sku[this.currentIndex])

    },
    submitStatus() {
      this.$refs.skuForm.init()
      console.log(this.currentData, this.skuList[this.currentIndex1].status)
      if (this.skuList[this.currentIndex1].status == '0') {
        this.skuList[this.currentIndex1].status = '1'
      } else {
        this.skuList[this.currentIndex1].status = '0'
      }
      this.skuFormConfig.sku[this.currentIndex].status = this.skuList[this.currentIndex1].status
      console.log(this.skuFormConfig.sku[this.currentIndex1].status)
      // if (this.currentData.status == 1) {
      //   this.skuList[this.currentIndex].status = '0'
      // } else {
      //   this.skuList[this.currentIndex].status = '1'
      // }

      this.isStatus = false
      this.isU1 = false
    },
    getPlatInfo() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          this.serverRate = res.data.commissionProportion
          this.userRate = res.data.platformInfo.normalCommissionProportion || 0
          this.firstNormalCommProp = res.data.platformInfo.firstNormalCommProp || 0
        }
      })
    },
    getPlatformStatistics() {
      this.axios.get('/earnestMoney/getPlatformStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.hadRechargeAmount = res.data.hadRechargeAmount;
            this.awaitEarnestMoney = res.data.awaitEarnestMoney;
            this.activeEarnestMoney = res.data.activeEarnestMoney;
            let total = 0
            console.log(this.skuFormConfig.sku)
            this.profit = this.skuFormConfig.sku.every((item) => item.platformProfitPrice > 0)
            console.log(this.profit)
            this.awaitEarnestMoney1 = 0
            this.skuFormConfig.sku.forEach(item => {
              total = total + item.platformProfitPrice * item.initSellNum
              if (item.platformProfitPrice < 0) {
                this.awaitEarnestMoney1 = Math.abs(this.awaitEarnestMoney1) + Math.abs(Number(item.platformProfitPrice).toFixed(2) * item.resetPriceNum)
                this.awaitEarnestMoney1 = Number(this.awaitEarnestMoney1).toFixed(2)
              }
            })
            // if (total - this.hadRechargeAmount < 0) {
            //   this.isSave = true
            // } else {
            //   this.isSave = false
            // }
          }
        })
    },
    upShop() {
      console.log('fields', this.$refs['skuForm'])
      let so = false;
      this.$refs['skuForm'].validate((valid) => {
        if (valid) {
          // this.$message.success('验证通过')
          so = false;
        } else {
          // this.$message.warning('验证失败')
          so = true
        }
      });
      if (so) return
      // console.log(this.isChange)
      // if (this.infoForm.goodsType == '赠品') {
      //   this.isInfo = true
      //   return
      // }
      // if (this.isChangeC == true) {
      //   this.isCostPrice = true
      //   return
      // }
      // if (this.isChange == true) {
      //   this.isUp = true
      //   this.getPlatformStatistics()
      //   return
      // } else {
      //   this.isInfo = true
      // }

    },
    changeImage(val) {
      console.log(val)
      this.fileList = val
    },
    showDialogSkuVisible(e, scope) {
      console.log(e, scope)
      if (scope.row.bindingSkuNo) {
        this.bindingSkuNo = scope.row.bindingSkuNo
      } else {
        this.bindingSkuNo = ''
      }
      console.log(this.skuFormConfig)
      this.dialogSkuVisible = true;
      this.skuIndex = scope.$index;
    },
    bindSku() {
      if (this.bindingSkuNo == '' || this.checknumber(this.bindingSkuNo)) {
        this.$message({
          message: '请输入正确的shu编码',
          type: 'error'
        })
        return
      }
      console.log(this.skuFormConfig, this.skuIndex)
      this.dialogSkuVisible = false;
      this.skuFormConfig.sku[this.skuIndex].bindingSkuNo = this.bindingSkuNo;
      this.$forceUpdate()
      this.bindingSkuNo = '';
    },
    checknumber(String) {
      var Letters = "1234567890";
      var i;
      var c;
      for (i = 0; i < String.length; i++) {
        c = String.charAt(i);
        if (Letters.indexOf(c) == -1) {
          return true;
        }
      }
      return false;
    },

    fetchData(type) {
      this.labelPageNo = 1
      this.labelPageSize = 10
      if (type == 'reset') {
        this.$refs['tagForm'].resetFields()
        this.labelPageNo = 1
        this.labelPageSize = 10
      } else {

      }
      this.getTagList()
    },
    //选择标签
    handleSelectTag(scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          tagName: scope.row.tagName
        };

        this.seletedTag.push(data)
        this.tagList[scope.$index].selected = true;
      } else {

        let idx = this.seletedTag.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedTag.splice(idx, 1)
        this.tagList[scope.$index].selected = false;
      }
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      console.log(this.seletedTag)
      this.$forceUpdate()
    },
    //批量选择、批量取消标签
    batchSelectTag(type) {
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            tagName: i.tagName
          }
        }
      })
      this.seletedTag = arr;
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    // //标签多选
    // handleSelectionChange (val) {
    //   this.tagSelectionList = val;
    // },
    onSizeChange(e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange(e) {
      this.labelPageNo = e;
      this.getTagList()
    },
    deleteTag(idx) {
      this.tagList.forEach(item => {
        if (this.seletedTag[idx].id == item.id) {
          item.selected = false;
        }
      })
      this.seletedTag.splice(idx, 1)

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    selectTagFn(idx) {
      if (!this.tagList[idx].select) {
        this.tagList[idx].select = !this.tagList[idx].select;
        this.seletedTag.push(this.tagList[idx])
        this.infoForm.tagList = this.seletedTag.map(item => {
          return item.id
        })
      }

    },
    // //获取标签数据
    // getTagList() {
    //   let data = {
    //     pageNo: this.labelPageNo,
    //     pageSize: this.labelPageSize
    //   }
    //   data = Object.assign(data, this.tagForm)
    //   this.$api.selectTagDataPage(data)
    //     .then(res => {
    //       console.log(res);
    //       res.data.list.forEach(item => {
    //         item.selected = false
    //       })
    //       this.tagList = res.data.list;
    //       this.seletedTag.forEach(item => {
    //         this.tagList.forEach(el => {
    //           if (item.id == el.id) {
    //             el.selected = true;
    //           }
    //         })
    //       })

    //       this.labelTotalNum = res.data.totalNum;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // },
    //获取标签数据
    getSelectTagData() {
      this.$api.selectTagData({})
        .then(res => {
          // this.tagList = res.data;
          console.log()
          this.tagList = res.data.map(item => {
            return { tagName: item.tagName, id: item.id, select: false }
          })

        })
        .catch(err => {
          console.log(err);
        })
    },
    onChangeSkuStatus(e, row) {
      // console.log('onChangeSkuStatus', e, row)
      this.checkGift = { type: 'row', value: row }
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        if (row.skuNo == s.skuNo && row.status === '0') {
          nSkuIds.push(s.id)
          this.checkGift.value['id'] = s.id
        }
      })
      if (nSkuIds.length > 0) { this.checkGiftListBySkuId(nSkuIds) }
    },
    isActionCheckGift(newVal, oldVal) {
      // const rQuery = this.$route.query
      const lastSkuStatus = this.lastSkuStatus
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        newVal.sku.forEach(nItem => {
          if (nItem.status == 0 && nItem.skuNo !== '') {
            if (nItem.skuNo == s.skuNo) {
              nSkuIds.push(s.id)
            }
          }
        })
      })
      this.lastSkuStatus = nSkuIds
      console.log(nSkuIds.length, nSkuIds, lastSkuStatus.length, lastSkuStatus)
      if (nSkuIds.length > lastSkuStatus.length) {
        // this.checkGiftListBySkuId(nSkuIds)
      }
      // this.checkGiftListBySkuId (nSkuIds)
    },
    checkGiftListBySkuId(skuIds, type) {
      return new Promise((resolve, reject) => {
        this.$api.giftListBySkuId(skuIds).then((res) => {
          this.giftListByGoodId = res.data
          if (res.data.length > 0) {
            const titleArr = []
            titleArr.push(this.infoForm.name)
            if (!type) { this.showModifyState(res.data, titleArr) }
            // console.log('giftListByGoodId', res.data)
          }
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      })
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'goodsList'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })

      // 查看成本价权限
      console.log('查看成本价权限', this.parArray.indexOf('eidt_chengbenjia'), this.parArray.indexOf('eidt_chengbenjia') != -1, this.parArray)
      if (this.parArray.indexOf('eidt_chengbenjia') === -1) {
        this.skuFormConfig.structure.forEach((item, index) => {
          if (item.name === 'costPrice') {
            this.skuFormConfig.structure.splice(index, 1)
          }
        })
      }
    },
    // 接受表单组件的数据
    dialogClick(val, state) {
      // console.log(val, state)
      this.formFiledDataState = state
      this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    getImage(val, scope) {
      console.log(val)
      console.log(this.skuFormConfig)
      // this.skuFormConfig.sku[scope.$index].Img = val
      // this.skuFormConfig.attribute[scope.$index].Img = val
      this.infoForm.skuList[scope.$index].image = val
      scope.row.image = val
      this.$refs.skuForm.validateFieldByRows(scope.$index, 'image', () => { })
    },
    // 初始化 信息
    initialization() {
      const queryObj = this.$route.query
      let category
      // 判断是否有 商品 ID 和 TYPE 类型 双从判断 当前页面状态
      // 获取商品信息 - 编辑模式
      if (queryObj.id && queryObj.type === 'edit') {
        // console.log(queryObj)
        // this.getPlatInfo()
        this.getModelsList()
        // this.getTagList()
        // this.getsTagList()
        // this.getmTagList()
        this.getGoodInfo(queryObj.id)
        this.currentPageStatus = 'edit'
        this.submitButtonText = '修改商品'

      }
    },
    getmTagList() {
      this.tagMarketingsT = []
      this.tagMarketing = []
      let data = {
        pageNo: 1,
        pageSize: 100000
      }
      this.axios.post('/tagPool/marketing/pageList', data)
        .then(res => {
          this.tagMarketings = res.data.list;
          if (this.infoForm.tagMarketing) {
            console.log(this.infoForm.tagMarketing)
            this.infoForm.tagMarketing.forEach(item => {
              if (item.selected == 1) {
                this.tagMarketingsT.push(item.id)
              }

            })
            console.log(this.tagMarketingsT)
            this.tagMarketings.forEach(item => {
              this.tagMarketingsT.forEach(itm => {
                if (item.id == itm) {
                  let obj = {
                    id: item.id,
                    name: item.name,
                    selected: 1
                  }
                  this.tagMarketing.push(obj)
                }
              })

            })
            console.log(this.tagMarketing)
          }

        })

    },
    getTagList() {
      this.tagIds = []
      this.axios.post('/tagPool/filter/categoryList', {})
        .then(res => {
          res.data.forEach(item => {
            let obj = {
              value: item.dictId,
              label: item.dictName,
              children: []
            }
            this.tagIds.push(obj)
          })
          this.getSecondTag()
        })
    },
    getSecondTag() {
      let data = {
        pageNo: 1,
        pageSize: 100000,
        goodsType: '1',
        status: 1,
        isShow: 1
      }
      this.axios.post('/tagPool/filter/pageList', data)
        .then(res => {
          this.tagIds2 = res.data.list
          res.data.list.forEach(item => {
            item.id = String(item.id)
            item.label = item.name
            this.tagIds.forEach(itm => {
              if (item.pid == itm.value) {
                let obj = {
                  value: item.id,
                  label: item.label,
                }
                itm.children.push(obj)
              }
            })
          })

          this.tagIds1 = this.tagIds

          console.log(this.tagIds1, res.data.tag)
          this.infoForm.tag.forEach(item => {
            for (let i = 0; i < this.tagIds1.length; i++) {
              if (item.id == this.tagIds1[i].value) {
                this.Tag[i] = []
                item.childTags.forEach(itm => {
                  if (itm.selected == 1) {
                    this.Tag[i].push(String(itm.id))
                  }

                })
                console.log(this.Tag[i])
              }
            }
          })
          this.selectT()
        })
    },
    getsTagList() {
      this.tagIdsShow = []
      this.axios.post('/tagPool/show/categoryList', {})
        .then(res => {
          res.data.forEach(item => {
            let obj = {
              value: item.dictId,
              label: item.dictName,
              children: []
            }
            this.tagIdsShow.push(obj)
          })
          this.getSecondsTag()
        })
    },
    getSecondsTag() {
      let data = {
        pageNo: 1,
        pageSize: 100000,
        categoryFirst: '1'
      }
      this.axios.post('/tagPool/show/pageList', data)
        .then(res => {
          this.tagIdsShow2 = res.data.list
          res.data.list.forEach(item => {
            item.id = String(item.id)
            item.label = item.name
            this.tagIdsShow.forEach(itm => {
              if (item.pid == itm.value) {
                let obj = {
                  value: item.id,
                  label: item.label,
                }
                itm.children.push(obj)
              }
            })
          })

          this.tagIdsShow1 = this.tagIdsShow
          console.log(this.tagIdsShow1)
          this.infoForm.tagStore.forEach(item => {
            for (let i = 0; i < this.tagIdsShow1.length; i++) {
              if (item.id == this.tagIdsShow1[i].value) {
                this.Tag1[i] = []
                item.childTags.forEach(itm => {
                  if (itm.selected == 1) {
                    this.Tag1[i].push(String(itm.id))
                  }

                })
                console.log(this.Tag1[i])
              }
            }
          })
          this.selectTs()
        })
    },
    skuItemHandle(item) {
      console.log(item)
      let tempSkuName = ''; let differenceStr = ''
      if (item.secondGoodsSpecItemId && item.thirdGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent},${item.thirdGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId},${item.thirdGoodsSpecItemId}`
      } else if (item.secondGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId}`
      } else {
        tempSkuName = `${item.firstGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId}`
      }
      // let platformUserCommission = Number((item.retailPrice * item.platformCommissionRate) / 100) + Number((item.retailPrice * item.firstNormalCommProp) / 100)
      const tempSKU = {
        id: item.id,
        sku: tempSkuName,
        difference: `${differenceStr}`,
        skuNo: item.skuNo,
        stock: item.stock,
        status: item.status,
        costPrice: item.costPrice,
        marketPrice: item.marketPrice,
        retailPrice: item.retailPrice,
        settlementPrice: item.settlementPrice,
        resetPriceNum: item.resetPriceNum,
        purchasePrice: item.purchasePrice,
        initSellNum: item.initSellNum,
        image: item.image,
        wyStatus: item.wyStatus,
        weight: item.weight,
        skuB: item.sku

      }
      console.log(tempSKU)
      return tempSKU
    },
    getModelsList() {
      let data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.axios.post('/shippingTemplate/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.models = this.models.concat(res.data.list)
          }
        })
    },
    //获取模板详情
    getTransportModel(val) {
      console.log(val)
      if (val == 0) {
        this.tableData = []
        this.tableDataF = []
        this.detail.calculType = ''
        return
      }
      let data = {
        id: val
      }
      this.axios.post('/shippingTemplate/get', data)
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data ? res.data : null
            this.tableData = this.detail ? this.detail.regions : []
            if (this.tableData) {
              this.tableData.forEach(item => {
                Object.assign(item, { address: item.betterAddress })
                if (item.regionJson) {
                  Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                }

              })
            }


            this.tableDataF = this.detail && this.detail.freeList ? this.detail.freeList : []
            if (this.tableDataF) {
              this.tableDataF.forEach(item => {
                Object.assign(item, { address: item.betterAddress })
                Object.assign(item, { addressData: JSON.parse(item.regionJson) })
              })
            }

            this.arr = []
            if (this.detail) {
              this.arr.push(String(this.detail.isFree))
            }
            // if (this.$route.query.oType == 0) {
            //   if (this.detail && this.detail.calculType == 2) {
            //     this.skuFormConfig.structure.splice(3, 1)
            //     if (this.infoForm.platformIdOrigin == 0) {
            //       this.skuFormConfig.structure.splice(13, 1)
            //       // this.isUpdate = true
            //     } else {
            //       this.skuFormConfig.structure.splice(12, 1)
            //       // this.isUpdate = false
            //     }
            //   } else {
            //     this.skuFormConfig.structure.splice(0, 1)
            //     this.skuFormConfig.structure.splice(2, 1)
            //     if (this.infoForm.platformIdOrigin == 0) {
            //       this.skuFormConfig.structure.splice(12, 1)
            //       // this.isUpdate = true
            //     } else {
            //       this.skuFormConfig.structure.splice(11, 1)
            //       // this.isUpdate = false
            //     }
            //   }

            // } else {
            //   console.log(666666, this.detail)
            //   if (this.detail && this.detail.calculType == 2) {
            //     console.log(555)
            //     this.skuFormConfig.structure.splice(13, 1)
            //   } else {
            //     this.skuFormConfig.structure.splice(0, 1)
            //     this.skuFormConfig.structure.splice(12, 1)
            //   }

            // }
            this.$forceUpdate()
          }
        })

    },
    // 获取 商品信息
    getGoodInfo(goodsId) {
      this.breadcrumbTitle = '编辑商品'
      const data = { id: goodsId }

      this.axios.post('/goods/details', data).then((res) => {
        const categoryId = res.data.categoryId
        this.infoForm = Object.assign(this.infoForm, res.data)
        this.fileList = this.infoForm.imageList
        this.skuFormConfig.structure = this.skuFormConfig.structure
        this.getmTagList()
        this.getTagList()
        this.getsTagList()
        console.log(this.Tag[0])
        if (res.data.shippingTemplateId) {
          this.getTransportModel(res.data.shippingTemplateId)
        }
        // 回显类目ID
        this.infoForm.categoryId = categoryId
        // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
        this.getDataList(categoryId, res.data.attrGroupList)

        this.getGoodsSaleDataList(categoryId, res.data.specList, res.data.skuList)
        const tempskuList = []
        res.data.skuList.forEach(e => {
          const itemHandle = this.skuItemHandle(e)
          tempskuList.push(itemHandle)
        })
        this.skuList = tempskuList
        this.isUpdate = true
        console.log(this.skuFormConfig)
        this.$forceUpdate()
        // this.skuItemHandle()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList(categoryInfo, categoryInfoList) {
      // console.log(categoryInfo)
      let data = {
        pageNo: 1,
        pageSize: 10000,
        categoryName: '',
        categoryNo: '',
        status: null
      }
      this.axios.post('/category/pageList', data).then((res) => {
        this.categoryList = res.data.list
        this.onChangeEditClassId(categoryInfo, categoryInfoList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
    getDataList(categoryId, attrGroupList) {
      // const params = { categoryId }
      this.axios.post('/goods/attrDataList?categoryId=' + categoryId).then((res) => {
        const resData = res.data
        const arr = []
        // debugger
        resData.forEach(firstItem => {
          const obj = {
            name: firstItem.name,
            id: firstItem.id,
            // 表单宽度  表单的list 表单的匹配规则
            formconfig: { labeWidth: 100, itemList: [], rules: {} },
            // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
            formData: {}
          }
          firstItem.itemList.forEach(secondItem => {
            // 字典 goods_attr_type
            // 1、文本 2、单选  3、多选  4、时间
            const type = Number(secondItem.typeFlag)
            let propId
            /*
            // 修改模式下，需要多添加一个 ID
            if(this.currentPageStatus == "edit"){
              attrGroupList.forEach( aItem => {
                aItem.itemList.forEach( aItemList => {
                  if(aItem.id == firstItem.id && aItemList.id == secondItem.id){
                    propId = `value-${firstItem.id}-${secondItem.id}-${aItemList.id}`;
                  }
                })
              })
            } else {
              propId = `value-${firstItem.id}-${secondItem.id}`;
            }
            */
            propId = `value-${firstItem.id}-${secondItem.id}`
            switch (type) {
              case 1: // 文本
                obj.formconfig.itemList.push({ type: 'input', prop: propId, placeholder: '请输入内容', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请输入内容', trigger: 'blur' }] })
                break
              case 2: // 单选
                const radiosArr = []
                /*
              secondItem.itemList.forEach( radiosItem => { radiosArr.push({label:radiosItem.label,value:radiosItem.id}) })
              obj.formconfig.itemList.push( { type:'radio', prop:propId, label:secondItem.name, radios:radiosArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ required: secondItem.requiredFlag == 0 ? false :true, message: '请选择内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(item => { radiosArr.push({ label: item.label, value: item.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: radiosArr, isMultiple: false })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请选择内容', trigger: 'change' }] })
                break
              case 3: // 多选
                // debugger
                const checkboxArr = []
                /*
              secondItem.itemList.forEach( checkboxItem => { checkboxArr.push({label:checkboxItem.label,value:checkboxItem.id}) })
              obj.formconfig.itemList.push( { type:'checkbox',prop:propId,label:secondItem.name, checkboxs:checkboxArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ type: 'array', required: secondItem.requiredFlag == 0 ? false :true, message: '请至少选择一个内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(checkboxItem => { checkboxArr.push({ label: checkboxItem.label, value: checkboxItem.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: checkboxArr, isMultiple: true, isCollapseTags: true })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请至少选择一个内容', trigger: 'blur' }] })
                // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
                // obj.formData = Object.assign(obj.formData, {[propId]:[]})
                break
              case 4: // 时间
                obj.formconfig.itemList.push({ type: 'datapicker', prop: propId, placeholder: '请选择日期', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ type: 'string', required: secondItem.requiredFlag != 0, message: '请选择日期', trigger: 'change' }] })
                break
              default: // 出错 - 不在设计范围
                console.log(typeof type, type)
              // 默认代码块
            }
          })
          arr.push(obj)
        })
        this.goodsAttrData = arr
        // 编辑状态下 类目属性 回显 值
        if (this.currentPageStatus === 'edit') { this.showGoodsAttrValue(arr) }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 编辑状态下 类目属性 回显 值
    showGoodsAttrValue(arr) {
      const attrGroupList = this.infoForm.attrGroupList
      // const original = [...arr]
      // this.goodsAttrData[0].formData["value-15-20"] = "20"
      // 准备匹配值
      attrGroupList.forEach(firstItem => {
        firstItem.itemList.forEach(secondItem => {
          secondItem.matchValue = `value-${firstItem.id}-${secondItem.id}`
        })
      })
      this.goodsAttrData.forEach((firstItem, firstIndex) => {
        firstItem.formconfig.itemList.forEach(secondItem => {
          attrGroupList.forEach(attFirstItem => {
            attFirstItem.itemList.forEach(attSecondItem => {
              if (attSecondItem.matchValue == secondItem.prop) {
                // 1、文本 2、单选  3、多选  4、时间
                switch (attSecondItem.typeFlag) {
                  case '1': // 文本
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '2': // 单选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '3': // 多选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  default: // 时间
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = attSecondItem.attrValueContent
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                }
              }
            })
          })
        })
      })
      // console.log(this.goodsAttrData[1].formData["value-15-20"])
    },
    // 选择销售属性
    onChangeGoodsSaleDataListValue(selectArr) {
      // sessionStorage.setItem('saleDataListValue', JSON.stringify(this.goodsSaleDataListValue))
      // this.skuFormConfig.attribute.splice(fatherIndex, 1)
      if (this.skuFormConfig.attribute.length >= 3) {
        console.log(this.skuFormConfig.attribute.length)
        console.log(selectArr.length)
        if (selectArr.length === 3) { selectArr.splice(3) }
        if (selectArr.length === 2) { selectArr.splice(2) }
        if (selectArr.length === 1) { selectArr.splice(1) }
      }
      this.goodsSaleDataListValue = selectArr
      const sourceAttribute = this.skuFormConfig.sourceAttribute
      const arr = []
      selectArr.forEach(item => {
        const matching = sourceAttribute.find(e => { return e.id === item })
        // console.log(matching)
        arr.push(matching)
      })
      const tempAttribute = []
      this.skuFormConfig.attribute.forEach(item => {
        if (item.id === undefined) {
          tempAttribute.push(item)
        }
      })
      this.skuFormConfig.attribute = tempAttribute
      // this.skuFormConfig.attribute = arr // SKU已选属性
      this.skuFormConfig.attribute = Array.from(new Set(this.skuFormConfig.attribute.concat(arr)))
      // ============== 初始 空数组，使用在添加新的属性  ==============
      this.skuFormConfig.inputValueArr = []
      this.skuFormConfig.inputValueArrTemp = []
      this.skuFormConfig.attribute.forEach((item, index) => {
        // this.skuFormConfig.inputValueArr.push({ name: '', item: [], itemList: [] })
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    onExceed() {
      selectArr.splice(selectArr.length - 1, 1)
      this.goodsSaleDataListValue = selectArr
      console.log('已经超出', this.goodsSaleDataListValue)
      console.log('已经超出', this.skuFormConfig.attribute)
    },
    // 查询指定类目的销售属性
    getGoodsSaleDataList(categoryId, goodsSpecList, goodsSpecTable) {
      this.skuFormConfig.sourceAttribute = [] // SKU可选属性
      // ============== 初始 回显 已选 SKU 值  ==============
      if (goodsSpecList && goodsSpecList.length !== 0) {
        goodsSpecList = goodsSpecList.sort(function (a, b) { return a.id - b.id })
        goodsSpecList.forEach(firstItem => {
          const itemArr = []
          firstItem.itemList.forEach(secondItem => {
            itemArr.push(secondItem.content)
          })
          firstItem.item = itemArr
        })
        this.skuFormConfig.attribute = goodsSpecList
        const tempSourceAttribute = Array.from(new Set(this.skuFormConfig.sourceAttribute.concat(goodsSpecList).filter(Boolean)))

        /**
         * 删除数组对象中重复的对象
         * arr: 源数组   filterField: 需要删除的重复字段，注意是字符串类型
         * 返回一个过滤好的，没有重复该字段filterField的数组
         * */
        const filterArrObj = (arr, filterField) => {
          const newArr = arr.reduce((pre, cur) => pre.some(item => item[filterField] == cur[filterField])
            ? pre : [...pre, cur], [])
          return newArr
        }
        this.skuFormConfig.sourceAttribute = filterArrObj(tempSourceAttribute, 'name')
        console.log(this.skuFormConfig)
        // const echoSpecList = []
      }

      if (goodsSpecTable && goodsSpecTable.length !== 0) {
        goodsSpecTable.forEach(item => {
          const arr = []
          arr.push(item.firstGoodsSpecItemContent)
          if (item.secondGoodsSpecItemContent) { arr.push(item.secondGoodsSpecItemContent) }
          if (item.thirdGoodsSpecItemContent) { arr.push(item.thirdGoodsSpecItemContent) }
          item.skuB = item.sku
          item.sku = arr.join(';')
          item.status = item.status.toString()
          item.wyStatus = item.wyStatus.toString()
        })
        this.skuFormConfig.sku = Array.from(new Set(goodsSpecTable))
        // 还原数据时，SKU组件将 ID 过滤掉，先将 数据缓存到本地，提交数据时使用
        sessionStorage.setItem('skuFormConfigSku', JSON.stringify(goodsSpecTable))
      }

      this.skuFormConfig.attribute.forEach((item, index) => {
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      console.log('表刚刚改', this.skuFormConfig)
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    // 获取 品牌 列表
    getBrandList(categoryId) {
      const params = { pageNo: 1, pageSize: 999, categoryId }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
        this.brandList.push({
          id: '-1',
          name: '其它'
        })
        console.log(this.brandList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // console.log(val)
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 修改 回显 classId
    onChangeEditClassId(categoryIdInfo, categoryInfoList) {
      // debugger
      let categoryId
      let categoryArrStr = ''
      if (typeof categoryIdInfo === 'string') {
        categoryId = categoryIdInfo
      } else {
        categoryId = categoryIdInfo[categoryIdInfo.length - 1]
      }
      const categoryList = this.categoryList
      if (categoryList.length < 0) { console.log('categoryList没到位！', categoryList) }
      const arr = []
      categoryList.forEach((firstItem, firstIndex) => {
        if (firstItem.id === categoryId) {
          console.log(firstItem.label)
          categoryArrStr = firstItem.label
          arr.push(firstItem.id)
          return
        }
        if (firstItem.children) {
          firstItem.children.forEach((secondItem, secondIndex) => {
            if (secondItem.id === categoryId) {
              categoryArrStr = `${firstItem.label} > ${secondItem.label}`
              arr.push(firstItem.id)
              arr.push(secondItem.id)
              return
            }
            if (secondItem.children) {
              secondItem.children.forEach((thirdItem, thirdIndex) => {
                if (thirdItem.id === categoryId) {
                  categoryArrStr = `${firstItem.label} > ${secondItem.label} > ${thirdItem.label}`
                  arr.push(firstItem.id)
                  arr.push(secondItem.id)
                  arr.push(thirdItem.id)
                  return
                }
              }) // third end
            }
          }) // second end
        }
      }) // first end

      if (categoryArrStr.length == '' || categoryArrStr.length < 0) {
        if (categoryInfoList) {
          categoryInfoList.reverse()
          const tempArr = []
          categoryInfoList.forEach(item => {
            tempArr.push(item.categoryName)
          })
          categoryArrStr = tempArr.join(' > ')
          console.log(categoryArrStr)
        } else {
          console.log('还没选择商品分类1', categoryArrStr)
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
      this.categoryArrStr = categoryArrStr
    },
    // 生成sku编码
    getSkuNo(id) {
      // 主键id请求
      const params = { id }
      this.$api.gkuNoByGoodId(params).then((res) => {
        this.maxSkuNo = Number(res.data) // 获取 的 skuNo 转数字，方便后面使用可以自增
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单规则验证
    async verificationData() {
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      // if (infoForm.name && infoForm.name !== '') {
      //   const goodsId = infoForm.id || ''
      //   const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
      //   // console.log('isRepeatGoodsName', isRepeatGoodsName)
      //   if (isRepeatGoodsName.code !== 0) {
      //     // this.$message.warning('商品名称有重名，请重新输入！')
      //     return console.log("商品有重名")
      //   }
      // }
      if (this.fileList.length == 0) {
        this.$message.warning('请上传商品图片')
        return
      }
      if (this.infoForm.details == '') {
        this.$message.warning('请填写商品详情')
        return
      }
      if (this.skuFormConfig.attribute.length == 0) {
        this.$message.warning('请添加规格')
        return
      }
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          this.$refs.skuForm.validate(valid => {
            if (valid) {
              // this.$message.success('skuForm验证通过')
              // 图片信息检查
              this.infoForm.imageList = this.fileList
              if (this.infoForm.imageList.length !== 0) {
                if (this.formFiledDataState) {
                  this.submitDate()
                } else {
                  this.$message.warning('请完善类目属性再提交！')
                }
              } else {
                this.$message.warning('请完善图片信息再提交！')
              }
            } else {
              // this.$message.warning('skuForm验证失败')
              return
            }
          })
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    },
    // 提交 数据
    async submitDate() {
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      // const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      // if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      // const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      // if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表
      // 规格列表
      const skuFormConfigAttribute = this.skuFormConfig.attribute
      skuFormConfigAttribute.forEach(firstItem => {
        firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
        firstItem.itemList.forEach(secondItem => {
          secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
        })
      })

      // 合并新添加的规格值
      skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
        const inputValueArr = this.skuFormConfig.inputValueArr
        firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
        firstItem.itemList = Array.from(new Set(firstItem.itemList))
      })
      params.specList = skuFormConfigAttribute

      const tempAttribute = this.skuFormConfig.attribute
      const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
      console.log(skuFormConfigSku)
      skuFormConfigSku.forEach(item => {
        console.log(item.sku)
        item.sku = item.sku.split(';')
      })
      skuFormConfigSku.forEach((firstItem, firstIndex) => {
        const attributeLength = skuFormConfigAttribute.length
        firstItem.sort = 1
        firstItem.sku.forEach((secondItem, secondIndex) => {
          switch (attributeLength) {
            case 1:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              break
            case 2:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              break
            case 3:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.thirdGoodsSpecName = tempAttribute[2].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
              break
          }
        })
      })
      const currentPageStatus = this.currentPageStatus
      // 编辑时，给SKU添加ID   获取 缓存 数据 匹配 ID
      if (currentPageStatus === 'edit') {
        // console.log("页面状态", typeof currentPageStatus, currentPageStatus)
        // const skuFormConfigSkuLs = Array.from(new Set(JSON.parse(sessionStorage.getItem('skuFormConfigSku'))))
        const skuFormConfigSkuls = JSON.parse(sessionStorage.getItem('skuFormConfigSku'))
        skuFormConfigSku.forEach(item => {
          skuFormConfigSkuls.forEach(itemLs => {
            if (item.skuNo === itemLs.skuNo) {
              item.id = itemLs.id
            }
          })
        })
      }

      // 添加模式下 添加 skuNo 编号
      if (currentPageStatus === 'add') {
        skuFormConfigSku.forEach((item, index) => {
          item.skuNo = this.maxSkuNo
          item.skuNo = item.skuNo < 10 ? '0' + item.skuNo.toString() : item.skuNo.toString()
          this.maxSkuNo++
        })
      }

      // 复查 skuNo
      skuFormConfigSku.forEach((item, index) => {
        if (item.skuNo === '' || item.skuNo === undefined || item.skuNo === null) {
          // 生成sku编码
          const newSkuNo = this.maxSkuNo
          item.skuNo = newSkuNo < 10 ? '0' + newSkuNo.toString() : newSkuNo.toString()
          this.maxSkuNo++
        }
        // delete item.sku
        item.sku = item.skuB
        delete item.skuB
      })

      params.skuList = skuFormConfigSku
      // 图片列表 ，设置第一张图为主图

      params.imageList.forEach(item => {
        // item.goodsId = params.imageList[0].goodsId
        // if (!item.id) {
        //   item.id = null
        // }
        // item.sort = 0
        // item.deleteFlag = false
        item.mainFlag = 0
      })
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []
      if (params.skuList.length > 0) {
        params.skuList.forEach(e => {
          if (e.status === '0') { disableSkuArrId.push(e.id) }
        })
      }


      const actionArr = Array.from(new Set(tempGiftIdArr))

      // 编辑
      delete params.attrGroupList
      delete params.categoryInfo
      delete params.goodsNo
      // let data = {
      //   id: this.$route.query.id,
      //   name: params.name,
      //   skuList: this.skuList
      // }
      params.id = this.$route.query.id
      params.tag = this.tag
      params.tagStore = this.tagStore
      params.tagMarketing = this.tagMarketing
      if (this.time == 0) {
        this.time = 3; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);
        this.axios.post('/goods/addEdit', params).then((res) => {
          if (res.code === 0) {
            // this.$message({ type: 'success', message: '添加商品成功!' })
            this.$notify({
              title: '成功',
              message: '修改成功!',
              type: 'success',
              duration: 3000
            })
            this.isInfo = false
            this.toOtherPages('shopList')
          } else {
            this.time = 0
          }
        }).catch((err) => {
          console.log(err)
          this.initialization() // 初始化 信息
        })
      } else {
        this.$message.warning('已提交，无需再次提交')
        console.log('已提交，无需再次提交');
      }

    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/modifyState.scss";

.dItem {
  height: 22px;
  line-height: 22px;
  background-color: #f4f4f5;
  border: 1px solid #e9e9eb;
  color: #909399;
  font-size: 12px;
  border-radius: 4px;
}

.el-tag--dark {
  background-color: #2D46EE;
  border-color: #2D46EE;
  color: #fff;
}

.el-select[data-v-68607b2e] {
  border-left: none !important;
  border-right: none !important;
  border-radius: 5px;
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

::v-deep .rate .el-input__suffix {
  margin-top: 6px;
}

.line {
  width: 100%;
  height: 0px;
  border: 1px solid #c0c0cc;
  opacity: 0.5;
  margin-top: 6px;
}

.info-item {
  margin-bottom: 24px;
}

.info-bottom {
  width: 426px;
  min-height: 58px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 0px;

  .info-bottom-item {
    text-align: left;
    padding: 8px 14px;
  }
}

::v-deep.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    white-space: normal;
  }

  .el-dialog__header {
    text-align: left;
    border-bottom: none;
  }

  .info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
  }

  .info-b {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    opacity: 1;
    margin-top: 12px;
    text-align: left;
  }

  .info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
  }

  .info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }

  .info-s1 {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #e3e3e3;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
}

// .content{color: #333333!important;}
//删除全页面按钮边框
.el-button {
  border: none;
}

.image-text-form {
  .el-form {
    .el-form-item {
      &:first-child {
        .el-form-item__label {
          &:before {
            color: #ff0000;
            content: "*";
          }
        }
      }
    }
  }
}

.goods-category-edit {
  .edit-btn {
    background-color: #e3edff;
    color: #4168e7;
    font-size: 14px;
    text-align: center;
    width: 44px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    padding: 3px 8px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.status-box {
  font-size: 16px;
  height: 40px;
  line-height: 40px;

  .list,
  .right {
    float: left;
  }

  .list {
    width: 100px;
    text-align: center;
  }

  .right {
    padding-top: 15px;
    width: calc(100% - 100px);

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.bottom-but {
  margin-top: -20px;
  text-align: left;

  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button+.el-button {
    margin-left: 32px;
  }
}

.el-select {
  border-left: 1px solid #d8dce5;
  border-right: 1px solid #d8dce5;
  border-radius: 5px;

  input[type="text"],
  input[type="number"] {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}

.attr {
  margin-top: 0;
}

.content {
  padding-bottom: 10px !important;
}

//v1.4.0新增
.labelbox {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .labelitem {
    background-color: #f0f3fd;
    padding: 2px 20px;
    font-size: 14px;
    color: #4168e7;
    position: relative;
    margin-right: 20px;
    line-height: 28px;

    .labelicon {
      color: #4168e7;
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      right: -6px;
      top: -6px;
    }
  }
}

.loglabelbox {
  padding: 20px 0;
  box-sizing: border-box;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;

  .loglabeltopbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-bottom: 1px dashed #cccccc;

    .labelitem {
      background-color: #f0f3fd;
      padding: 2px 20px;
      font-size: 14px;
      color: #4168e7;
      position: relative;
      margin-right: 20px;
      margin-bottom: 14px;
      cursor: pointer;
    }

    .labelitemc {
      .labelicon {
        color: #4168e7;
        cursor: pointer;
        position: absolute;
        font-size: 16px;
        right: -6px;
        top: -6px;
      }
    }

    .notselected {
      background-color: #4168e7;
      color: #ffffff;
    }

    .selected {
      background-color: #f3f3f3;
      color: #333333;
    }
  }

  .circlebox {
    font-size: 16px;
    color: #4168e7;
    display: flex;
    margin-top: 14px;
    align-items: center;
    margin-bottom: 14px;

    .circle {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 50%;
      background-color: #4168e7;
      color: white;
      font-size: 12px;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.circle1 {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: #4168e7;
  color: white;
  font-size: 12px;
  margin-left: 10px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 4px;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168e7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-mini {
  width: 68px;
  height: 32px;
  background: #e3edff;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168e7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}

.primary-plain {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168e7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}

#goods-edit #sku-content .sku-box .sku-content-box {
  width: calc(100% - 10px);
}
</style>
